function _extends() {return _extends = Object.assign ? Object.assign.bind() : function (n) {for (var e = 1; e < arguments.length; e++) {var t = arguments[e];for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);}return n;}, _extends.apply(null, arguments);}var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);} /* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react';

import { useLoaderData } from 'react-router';
import { useAtomValue } from 'jotai';
import { intersectionBy, keyBy, merge, values } from 'lodash';
import { createColumnHelper } from '@tanstack/react-table';
import { Translate, I18NApi, t } from "../../../../I18N";
import { RequestParams } from "../../../../utils/RequestParams";
import { settingsAtom } from "../../../atoms/settingsAtom";
import { Button, Table, ConfirmationModal } from "../../../Components/UI";
import { useApiCaller } from "../../../CustomHooks/useApiCaller";
import { SettingsContent } from "../../../Components/Layouts/SettingsContent";

import { InstallLanguagesModal } from "./components/InstallLanguagesModal";
import {
  DefaultHeader,
  LabelHeader,
  ResetHeader,
  UninstallHeader,
  DefaultButton,
  ResetButton,
  UninstallButton,
  LanguageLabel } from "./components/TableComponents";



const columnHelper = createColumnHelper();

const languagesListLoader =
(headers) =>
async () =>
I18NApi.getLanguages(new RequestParams({}, headers));

// eslint-disable-next-line max-statements
const LanguagesList = () => {
  const { languages: collectionLanguages = [] } = useAtomValue(settingsAtom);
  const { requestAction } = useApiCaller();
  const [modalProps, setModalProps] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [showInstallModal, setShowInstallModal] = useState(false);

  const availableLanguages = useLoaderData();
  const installedLanguages = intersectionBy(availableLanguages, collectionLanguages, 'key');
  const notInstalledLanguages = availableLanguages.filter(
    (l) => !collectionLanguages.find((cl) => cl.key === l.key)
  );

  const languages = values(
    merge(keyBy(installedLanguages, 'key'), keyBy(collectionLanguages, 'key'))
  ).map((lang) => _objectSpread(_objectSpread({}, lang), {}, { rowId: lang._id }));

  const handleAction =
  (
  successMessage,
  action,
  key,
  currentLanguage) =>

  async () => {
    setShowModal(false);
    if (currentLanguage) {
      await requestAction(
        action,
        new RequestParams({ [key]: currentLanguage.key }),
        successMessage
      );
    }
  };

  const confirmAction = (
  message,
  acceptLabel,
  handleAcceptedAction) =>
  {
    setModalProps({
      header: t('System', 'Are you sure?', null, false),
      body: message,
      acceptButton: acceptLabel,
      cancelButton: t('System', 'No, cancel', null, false),
      warningText: t('System', 'Other users will be affected by this action!', null, false),
      confirmWord: t('System', 'CONFIRM', null, false),
      onAcceptClick: handleAcceptedAction,
      onCancelClick: () => setShowModal(false),
      size: 'md'
    });
    setShowModal(true);
  };

  const resetModal = (row) => {
    confirmAction(
      'You are about to reset a language.',
      'Reset',
      handleAction(/*#__PURE__*/
        _jsx(Translate, {}, void 0, "Language reset success"),
        I18NApi.populateTranslations,
        'locale',
        row.original
      )
    );
  };

  const setDefaultLanguage = async (row) => {
    await handleAction(/*#__PURE__*/
      _jsx(Translate, {}, void 0, "Default language change success"),
      I18NApi.setDefaultLanguage,
      'key',
      row.original
    )();
  };

  const uninstallModal = (row) => {
    confirmAction(
      'You are about to uninstall a language.',
      'Uninstall',
      handleAction(/*#__PURE__*/
        _jsx(Translate, { translationKey: "Language Uninstall Start Message" }, void 0, "Language uninstallation process initiated. It may take several minutes to complete depending on the size of the collection. Please wait until the uninstallation process is finished."



        ),
        I18NApi.deleteLanguage,
        'key',
        row.original
      )
    );
  };

  const columns = [
  columnHelper.accessor('label', {
    id: 'label',
    header: LabelHeader,
    cell: LanguageLabel,
    meta: { headerClassName: 'w-9/12' }
  }),
  columnHelper.accessor('default', {
    header: DefaultHeader,
    cell: DefaultButton,
    enableSorting: false,
    meta: { action: setDefaultLanguage, headerClassName: 'text-center w-1/12' }
  }),
  columnHelper.accessor('key', {
    header: ResetHeader,
    cell: ResetButton,
    enableSorting: false,
    meta: { action: resetModal, headerClassName: 'text-center w-1/12' }
  }),
  columnHelper.accessor('_id', {
    header: UninstallHeader,
    cell: UninstallButton,
    enableSorting: false,
    meta: { action: uninstallModal, headerClassName: 'text-center w-1/12' }
  })];


  return (/*#__PURE__*/
    _jsx("div", {
      className: "tw-content",
      style: { width: '100%', overflowY: 'auto' },
      "data-testid": "settings-languages" }, void 0, /*#__PURE__*/

    _jsx(SettingsContent, {}, void 0, /*#__PURE__*/
    _jsx(SettingsContent.Header, { title: "Languages" }), /*#__PURE__*/
    _jsx(SettingsContent.Body, {}, void 0, /*#__PURE__*/
    _jsx("div", { "data-testid": "languages" }, void 0, /*#__PURE__*/
    _jsx(Table, {
      columns: columns,
      data: languages,
      header: /*#__PURE__*/
      _jsx(Translate, { className: "text-base font-semibold text-left text-gray-900 bg-white" }, void 0, "Active languages"

      ),

      defaultSorting: [{ id: 'label', desc: false }] }
    )
    )
    ), /*#__PURE__*/
    _jsx(SettingsContent.Footer, {}, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex gap-2" }, void 0, /*#__PURE__*/
    _jsx(Button, {
      onClick: () => {
        setShowInstallModal(true);
      } }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Install Language(s)")
    )
    )
    )
    ),
    showModal && /*#__PURE__*/
    _jsx("div", { className: "container w-10 h-10" }, void 0, /*#__PURE__*/
    React.createElement(ConfirmationModal, _extends({}, modalProps, { size: "md" }))
    ),

    showInstallModal && /*#__PURE__*/
    _jsx(InstallLanguagesModal, {
      setShowModal: setShowInstallModal,
      languages: notInstalledLanguages }
    )

    ));

};


export { LanguagesList, languagesListLoader };